import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1', // Fallback added for safety
  headers: {
    'Content-Type': 'application/json',
  },
});

// Optional: Add interceptor for adding Auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken'); // Or however you store the token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: handles redirects, token expiration, and trailing slash issues
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 307 redirect for trailing slash issues automatically
    if (error.response && error.response.status === 307) {
      const redirectUrl = error.response.headers.location;
      if (redirectUrl) {
        // Create a new request with the redirected URL
        return apiClient.request({
          method: error.config.method,
          url: redirectUrl,
          data: error.config.data,
          headers: error.config.headers
        });
      }
    }

    // Handle token expiration
    if (error.response && error.response.status === 401) {
      const detail = error.response.data && error.response.data.detail;
      if (detail === 'Token has expired') {
        // Clear stored auth and redirect to login
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        window.location.href = '/login';
        return; // Prevent further promise chaining
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient; 